import React from "react";

type PaginationControlsProps = {
  currentPage: number;
  totalPages: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
  onItemsPerPageChange: (items: number) => void;
};

const PaginationControls: React.FC<PaginationControlsProps> = ({
  currentPage,
  totalPages,
  itemsPerPage,  
  onPageChange,
  onItemsPerPageChange,
}) => {
  return (
    <div className="flex justify-end items-center gap-2 px-5 mt-2">
      {/* Items Per Page Selector */}
      <div className="flex items-center gap-2">
        <label htmlFor="itemsPerPage" className="text-xs font-medium text-gray-700">
          Show:
        </label>
        <select
          id="itemsPerPage"
          value={itemsPerPage}
          onChange={(e) => {
            onItemsPerPageChange(Number(e.target.value));
            onPageChange(1); // Reset to page 1
          }}
          className="border rounded-md px-3 py-1 text-xs"
        >
           <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
          <option value={150}>150</option>
        </select>
      </div>

      {/* Prev Button */}
      <button
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        className="text-xs px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
      >
        Prev
      </button>

      {/* Page 1 always visible */}
      <button
        onClick={() => onPageChange(1)}
        className={`px-3 py-1 rounded text-xs ${
          currentPage === 1 ? "bg-[#184A84] text-white" : "bg-gray-100"
        }`}
      >
        1
      </button>

      {/* Dots before current page */}
      {currentPage > 3 && <span className="px-1">...</span>}

      {/* Current, prev, and next pages */}
      {Array.from({ length: totalPages }, (_, i) => i + 1)
        .filter(
          (pageNum) =>
            pageNum !== 1 &&
            pageNum !== totalPages &&
            Math.abs(pageNum - currentPage) <= 1
        )
        .map((pageNum) => (
          <button
            key={pageNum}
            onClick={() => onPageChange(pageNum)}
            className={`px-3 py-1 rounded text-xs ${
              currentPage === pageNum ? "bg-[#184A84] text-white" : "bg-gray-100"
            }`}
          >
            {pageNum}
          </button>
        ))}

      {/* Dots before last page */}
      {currentPage < totalPages - 2 && <span className="px-1">...</span>}

      {/* Last page */}
      {totalPages > 1 && (
        <button
          onClick={() => onPageChange(totalPages)}
          className={`px-3 py-1 rounded text-xs ${
            currentPage === totalPages ? "bg-[#184A84] text-white" : "bg-gray-100"
          }`}
        >
          {totalPages}
        </button>
      )}

      {/* Next Button */}
      <button
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        className="text-xs px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
      >
        Next
      </button>
    </div>
  );
};

export default PaginationControls;
